import { sidebarStore } from "Components/Core/Sidebar/SidebarStore";
import { MenuItemWithBadge, SubmenuItem } from "Components/Core/Sidebar/subMenus";

export const subMenuConfig = {
  get config(): SubmenuItem[] {
    const config = [];
    const mainModuleChildren = sidebarStore.menu?.find((m) => m.module === "BIM")?.children;

    mainModuleChildren.forEach((element) => {
      if (element.module === "BIM_ISSUES") {
        config.push({
          label: <MenuItemWithBadge label={"BCF-Issues"} />,
          link: `bcf-issues`,
          icon: "exclamation-square",
        });
      }
    });

    return config;
  },
};
